import React, { Component } from 'react';
import './styles.scss';
import { connect } from 'react-redux';
import BrokerUsers from './components/BrokerUsers';
import Box from '../../../../../../common/components/Box/Box';
import getIncludedResource from '../../../../../../helpers/getIncludedResource';
import { FieldArray, getFormValues } from 'redux-form';
import { Col, Row } from 'react-bootstrap';
//TODO refactor into different component for editing users
class Users extends Component {
  constructor(props) {
    super(props);
  }

  componentWillMount() {
    const { existingBroker, dispatch, change } = this.props;
    if (existingBroker) {
      const users = getIncludedResource(
        existingBroker.data,
        existingBroker.included,
        'users',
      );
      dispatch(change('data.relationships.users.data', users));
    }
  }

  render() {
    const { formValues, existingBroker } = this.props;
    const userPath = existingBroker
      ? 'data.relationships.users'
      : 'data.attributes.users';
    return (
      <Box>
        <Row>
          <Col sm={12}>
            <h4 className="page-title">Users</h4>
            <hr />
          </Col>
        </Row>
        <FieldArray name={userPath} formValues={formValues} component={BrokerUsers} />
      </Box>
    );
  }
}

// const form = reduxForm()(Users);
// const mapStateToProps = (state, props) => {
//   const values = formValueSelector(props.form)(state, 'data', 'data.attributes.users');
//
//   return {
//     auth: state.auth,
//     initialValues: props.resource,
//     form: props.form,
//     formValues: values,
//     destroyOnUnmount: false,
//     forceUnregisterOnUnmount: true,
//     product: state.product,
//   };
// };

//export default connect(mapStateToProps)(form);

export default connect((state, props) => {
  return {
    formValues: getFormValues(props.form)(state),
    product: state.product,
  };
})(Users);
